import React from 'react'

import { HeaderSeparator, ReportDatePicker, ReportHeader, ReportHeaderDates, ReportHeaderDesktopActions, ReportHeaderMobileActions, ReportMenuConfigure, ReportMobileMenu, RunButton } from '@/components/reports/header'

const ReportsProgressionHeader = ({ onChangeDates, dates, sync, isLoading, children }) => <ReportHeader title='Path Finder Report'>
  <ReportHeaderDates>
    <ReportDatePicker dates={dates} onChange={onChangeDates} />
  </ReportHeaderDates>
  <HeaderSeparator />
  <ReportHeaderDesktopActions>
    {children}
  </ReportHeaderDesktopActions>
  <ReportHeaderMobileActions>
    <ReportMobileMenu>
      <ReportMenuConfigure />
    </ReportMobileMenu>
    <RunButton isLoading={isLoading} disabled={isLoading} onClick={sync} />
  </ReportHeaderMobileActions>
</ReportHeader>

export default ReportsProgressionHeader
